import { z } from 'zod';
import { uuidSchema } from './common.js';
/** GET /audit-events query filters (BP-01 §2.6/§4). */
export const auditQuerySchema = z.object({
    actor: uuidSchema.optional(),
    action: z.string().max(80).optional(),
    objectType: z.string().max(80).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(100),
    cursor: z.string().optional(),
});
export const auditEventSchema = z.object({
    id: uuidSchema,
    orgId: uuidSchema.nullable(),
    actorUserId: uuidSchema.nullable(),
    impersonatorUserId: uuidSchema.nullable(),
    role: z.string().nullable(),
    action: z.string(),
    objectType: z.string().nullable(),
    objectId: z.string().nullable(),
    ip: z.string().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=audit.js.map